'use client';
import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

export default function AlertDialog({
  isOpen,
  close,
  title = '',
  desc = '',
  buttonText = '확인',
  successCb,
  dimCb,
}: {
  isOpen: boolean;
  close: () => void;
  title?: string;
  desc?: string;
  buttonText?: string;
  successCb?: () => void;
  dimCb?: () => void;
}) {
  return (
    <Dialog open={isOpen} as="div" className="dialog_alert" onClose={dimCb || close}>
      <div className="inner pad dim">
        <DialogPanel transition className="layer_alert">
          <div className="wrap_alert">
            {title !== '' && (
              <DialogTitle as="h3" className="title">
                {title}
              </DialogTitle>
            )}
            {desc !== '' && <p className="title_desc">{desc}</p>}
          </div>
          <div className="group_btn">
            <Button
              className="btn_primary"
              onClick={() => {
                close();
                successCb && successCb();
              }}
            >
              {buttonText}
            </Button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
